import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { academicStructureApi as api } from "@/lib/api/academicStructure";
import { structureCopy as words } from "./structure-copy";
/** The former term sheet is the term row's read-only review, never a dialog. */
export function TermSeasonRecord({ id, enabled }: {
    id: string;
    enabled: boolean;
}) {
    const query = useQuery({
        queryKey: ["semester-season", id], queryFn: () => api.getSemesterSeason(id), enabled
    });
    if (!enabled)
        return null;
    if (!query.data)
        return <p>{query.isPending ? "Reading the term review." : "The term review could not be read. This is not an all-clear."}{query.isError && <button type="button" onClick={() => { void query.refetch(); }}>Try again</button>}</p>;
    const review = query.data;
    const categories = [
        ["Published sections stay published", review.close_review.published_sections_remain_published],
        ["Scheduled sessions remain", review.close_review.scheduled_sessions],
        ["Attendance gaps", review.close_review.missing_attendance],
        ["Handed in, not yet released", review.close_review.handed_in_not_released],
        ["Returned, awaiting a new hand-in", review.close_review.returned_awaiting_resubmission],
        ["Results await proposal", review.close_review.unproposed_results],
        ["Proposals await certification", review.close_review.pending_certification],
    ] as const;
    return <section aria-label="Term review"><p>{review.term.status === "closed" ? "Historical term file" : "Term close review"}. These warnings do not block closing.</p>
    {query.isError && <p>{words.stale}</p>}
    <dl><dt>Sections</dt><dd>{review.season.section_count}</dd><dt>Credit enrollments (enrolled)</dt><dd>{review.season.active_enrollment_count}</dd><dt>Distinct credit learners (enrolled)</dt><dd>{review.season.distinct_enrolled_learner_count}</dd></dl>
    <p>Grades due: {review.term.grades_due_date ?? "Not set"}.</p>
    {categories.map(([name, rows]) => <section key={name}><h4>{name}: {rows.reduce((total, row) => total + (row.count ?? 1), 0)}</h4><ul>{rows.map((row, index) => <li key={`${row.course_id}/${row.assignment_id ?? row.session_id ?? row.enrollment_id ?? index}`}><Link data-nav="" to={row.href}>{[row.course_code, row.course_title, row.assignment_title, row.display_name, row.count === undefined ? null : `${row.count} ${row.count === 1 ? "learner" : "learners"}`].filter(Boolean).join(" · ")}</Link><span>{row.responsible_teaching_team.map(person => person.name).join(", ") || "No active teaching team"}</span></li>)}</ul></section>)}
  </section>;
}
